const sanitizeHtml = (htmlString) => {
    const parser = new DOMParser();
    // Parse the string into a full HTML document
    const doc = parser.parseFromString(htmlString, 'text/html');

    // The browser will have placed your content inside the <body> of this virtual doc
    // and automatically closed all tags.
    return doc.body.innerHTML;
};

export default sanitizeHtml;
